import { z } from 'zod';

// `Idempotency-Key` obligatoria en toda mutación con efecto económico (RF-07.03).
// La genera el cliente (un UUID por intención del usuario) y la repite si reintenta.

export const IDEMPOTENCY_KEY_HEADER = 'idempotency-key';
/** Cabecera de respuesta presente cuando se devuelve el resultado guardado de un intento anterior. */
export const IDEMPOTENT_REPLAY_HEADER = 'idempotent-replayed';

export const idempotencyKeySchema = z
  .string()
  .min(8)
  .max(255)
  .regex(/^[\x21-\x7E]+$/, 'Solo caracteres ASCII visibles, sin espacios.');

export const idempotencyHeadersSchema = z.object({
  [IDEMPOTENCY_KEY_HEADER]: idempotencyKeySchema.describe(
    'Clave única por operación. Repite la misma clave para reintentar sin cobrar dos veces.',
  ),
});
